import { render } from "./SuccessCheck.vue?vue&type=template&id=b08ca270"
import script from "./SuccessCheck.vue?vue&type=script&lang=js"
export * from "./SuccessCheck.vue?vue&type=script&lang=js"

import "./SuccessCheck.vue?vue&type=style&index=0&id=b08ca270&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\matress-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__